/** Derived lifecycle of an FEC import, from upload to "pushed to Billy" (backend ADVP-585). */
export enum FecImportLifecycleStatus {
  AwaitingProcessing = 'awaiting_processing',
  DetectingMappings = 'detecting_mappings',
  DetectionFailed = 'detection_failed',
  Done = 'done',
  InReview = 'in_review',
  Parsing = 'parsing',
  ParsingFailed = 'parsing_failed',
  PushFailed = 'push_failed',
  PushingToBilly = 'pushing_to_billy',
}
